import { STATUSES } from 'constants/common';
import { ENV_DEVELOPMENT } from 'constants/env';

export const isLessonReadOnly = (status: string): boolean => {
  if (ENV_DEVELOPMENT) {
    return false;
  }

  return status !== STATUSES.DRAFT;
};
